import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import ReactTable from "react-table";
import "react-table/react-table.css";
import couterpart from 'counterpart';
import DatePicker from 'react-datepicker';
import {ToastsContainer, ToastsStore} from 'react-toasts';
import Spinner from 'react-spinner-material';

import { FaFilter } from 'react-icons/fa';
import Dialog from 'react-bootstrap-dialog';
import "react-table/react-table.css";
import "../css/style.css";

import MenuComponent2 from './MenuComponent2';
import WorkOrderUtil from '../utilities/WorkOrderUtil';
import AuthenticationService from '../services/AuthenticationService';
import { ICON_COLOR} from '../icon';
import ErrorReportService from '../services/ErrorReportService';
import StatisticService from '../services/StatisticService';
import { Chart } from "react-google-charts";
import UserDataService from '../services/UserDataService';
import MasterDataService from '../services/MasterDataService';

class ErrorReport extends Component {
  constructor () {
    super();
    this.fileInputRef = React.createRef();

    let date = new Date();
    let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    let lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

    let fromDate = WorkOrderUtil.convertToyyyyMMddhhmmString(firstDay);
    let toDate = WorkOrderUtil.convertToyyyyMMddhhmmString(lastDay);
    this.loadErrorMasterData();

    this.loadErrorReporters();

    this.state = {
      errorReportStatistics: [],
      errorReportStatisticsByDays: [],
      filteredErrorDetailsByGroup: [],
      errorReporters: [],
      spinnerVisible: false,
      fromDate: fromDate,
      toDate: toDate,
      orderNo: null,
      pageSize: 10,
      page: 0,     
      errorReports: [],
      childRefreshCount: 0,
      show2: false,
      workOrder: {},
      tinhTrangSuCos: [],
      loaiSuCos: [
      ],
      workers: [],
      errorGroups: [],
      selectedRow: 0,
      selected: 0,
      childRefreshCount: 0,
      columns: [
        {
          id: "idx",
          accessor: "",
          width: 40,
          Cell: row => (
            <div style={{ padding: "10px" }}>{row.index + 1}</div>
          )
        },
        {
          id: "checkbox",
          accessor: "",
          Cell: ({ original }) => {
            return (
              <div style={{ textAlign: "center" }}>
                <input
                  type="checkbox"
                  className="checkbox"
                  checked={this.state.selected[original.id] === true}
                  onChange={() => this.toggleRow(original.id)}
                /></div>
            );
          },
          Header: x => {
            return (
              <input
                type="checkbox"
                className="checkbox"
                checked={this.state.selectAll === 1}
                ref={input => {
                  if (input) {
                    input.indeterminate = this.state.selectAll === 2;
                  }
                }}
                onChange={() => this.toggleSelectAll()}
              />
            );
          },
          sortable: false,
          width: 45
        }, {
          Header: couterpart.translate('quality_error_desc'),
          width: 250,
          accessor: 'errorDesc',
          filterable: false
        }, {
          Header: couterpart.translate('quality_error_pcode'),
          width: 150,
          accessor: 'info',
          filterable: false
        },{
          Header: couterpart.translate('quality_error_code_details'),
          accessor: 'errorCode',
          width: 200,
          Cell: props => this.getErrorDetails(props.value)
        },{
          Header: couterpart.translate('quality_error_code'),
          accessor: 'errorCode',
          width: 200,
          Cell: props => this.getErrorGroup(props.value)
        }, {
          Header: couterpart.translate('quality_error_worker'),
          width: 100,
          accessor: 'worker',
          filterable: false
        }, {
          Header: couterpart.translate('quality_error_created_at'),
          width: 250,
          accessor: 'createdAt',
          filterable: false
        }, {
          Header: couterpart.translate('quality_error_created_by'),
          width: 250,
          accessor: 'createdBy',
          filterable: false
        },]
    };
  }

  getErrorDetails(errorDetailsCode) {
    if (this.state.errorMasterData === undefined || this.state.errorMasterData === null) {
      return errorDetailsCode;
    }

    let errorMaster = this.state.errorMasterData.find(x => {
      return x.errorDetailsCode === errorDetailsCode;
    });
    if (errorMaster === undefined){
      return errorDetailsCode;
    }

    return errorMaster.errorDetailsName + " - " + errorMaster.errorDetailsCode;
  }

  getErrorGroup(errorDetailsCode) {
    if (this.state.errorMasterData === undefined || this.state.errorMasterData === null) {
      return errorDetailsCode;
    }

    let errorMaster = this.state.errorMasterData.find(x => {
      return x.errorDetailsCode === errorDetailsCode;
    });
    if (errorMaster === undefined){
      return errorDetailsCode;
    }

    return errorMaster.errorName + " - " + errorMaster.errorCode;
  }

  linkToDetails(row) {
    return (
      <label className="label_link" href="#!" onClick={() => { this.handleEdit(row) }}>{row.original.errorCode}</label>
    )
  }

  handleEdit(row) {
    
  }

  handleSelectChange(e){
    let value = e.target[e.target.selectedIndex].value;
    this.setState({
      selectedWorker: value
    });
  };

  handleErrorGroupSelectChange(e){
    let value = e.target[e.target.selectedIndex].value;
    this.setState({
      selectedErrorGroup: value
    }, () =>{
      let errs = [];
      if (this.state.selectedErrorGroup === undefined || this.state.selectedErrorGroup === ''){
        errs = this.state.errorMasterData;
      }
      errs = this.state.errorMasterData.filter(e => {
        return e.errorCode.indexOf(this.state.selectedErrorGroup) === 0;
      });
      this.setState({filteredErrorDetailsByGroup: errs }, () => {
          //this.selectDefaultError(errs[0]);
      });
    });
  };

  handleErrorDetailsSelectChange(e){
    let value = e.target[e.target.selectedIndex].value;
    this.setState({
      selectedErrorDetails: value
    });
  };

  renderWorkerOption(option){
      return (
          <option key={option.key} value={option.userName}>{option.userName}</option>
      );
  }

  renderErrorGroupOption(option){
      return (
          <option key={option.key} value={option.key}>{option.key + " - " + option.value}</option>
      );
  }

  renderErrorGroups(){
    if(this.state.errorGroups === undefined){
        return (<></>);
    }
    return(
    <>
      <select onChange={this.handleErrorGroupSelectChange.bind(this)} className="inputBox3" >
          <option key="" value=""></option>
          {this.state.errorGroups !== undefined && this.state.errorGroups.map(option =>this.renderErrorGroupOption(option))}
      </select>
    </>
    );
  }

  renderErrorDetailsOption(option){
      return (
          <option key={option.errorDetailsCode} value={option.errorDetailsCode}>{option.errorDetailsName + " - " + option.errorDetailsCode}</option>
      );
  }

  renderErrorDetails(){
    if(this.state.filteredErrorDetailsByGroup === undefined){
        return (<></>);
    }
    return(
    <>
      <select onChange={this.handleErrorDetailsSelectChange.bind(this)} className="inputBox3" >
          <option key="" value=""></option>
          {this.state.filteredErrorDetailsByGroup !== undefined && this.state.filteredErrorDetailsByGroup.map(option =>this.renderErrorDetailsOption(option))}
      </select>
    </>
    );
  }

  renderWorkers(){
    if(this.state.workers === undefined){
        return (<></>);
    }
    return(
    <>
      <select onChange={this.handleSelectChange.bind(this)} className="inputBox3" >
          <option key="" value=""></option>
          {this.state.workers !== undefined && this.state.workers.map(option =>this.renderWorkerOption(option))}
      </select>
    </>
    );
  }

  handleErrorReportersSelectChange(e){
    let value = e.target[e.target.selectedIndex].value;
    this.setState({
      selectedErrorReporter: value
    });
  };

  renderErrorReportersOption(option){
      return (
          <option key={option.id} value={option.username}>{option.username}</option>
      );
  }

  renderErrorReporters(){
    if(this.state.errorReporters === undefined){
        return (<></>);
    }
    return(
    <>
      <select onChange={this.handleErrorReportersSelectChange.bind(this)} className="inputBox3" >
          <option key="" value=""></option>
          {this.state.errorReporters !== undefined && this.state.errorReporters.map(option =>this.renderErrorReportersOption(option))}
      </select>
    </>
    );
  }

  loadWorkers() {
    UserDataService.retrieveWorkers().then(data => {
      let len = data.length;
      let workers = [];
      for (let i = 0; i < len; i++) {
        workers.push({ key: data[i].id, label: data[i].firstName + data[i].lastName, value: data[i].id, userName: data[i].userName })
      }
      this.setState({ workers: workers });
    });
  }

  loadErrorMasterData(){
    MasterDataService.retrieveErrorMasterDatas().then(data => {
      console.log("ERROR MASTER DATA", data);
      this.setState({ errorMasterData: data, filteredErrorDetailsByGroup: data });
    });
  }

  loadErrorReporters(){
    UserDataService.retrieveErrorReporters().then(data => {
      let len = data.length;
      let errorReporters = [];
      for (let i = 0; i < len; i++) {
        errorReporters.push({ key: data[i].id, label: data[i].username, value: data[i].id, username: data[i].username })
      }
      this.setState({ errorReporters: errorReporters });
    });
  }

  loadErrorGroups() {
    MasterDataService.retrieveErrorGroups("all").then(data => {
      let len = data.length;
      let errorGroups = [];
      for (let i = 0; i < len; i++) {
        errorGroups.push({ key: data[i].key, value: data[i].value })
      }
      this.setState({ errorGroups: errorGroups });
    });
  }

  componentDidMount () {
    this.loadWorkers();
    this.loadErrorGroups();
    let date = new Date();
    let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    let lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

    let fromDate = WorkOrderUtil.convertToyyyyMMddhhmmString(firstDay);
    let toDate = WorkOrderUtil.convertToyyyyMMddhhmmString(lastDay);
    let pageSize = 10;
    try {
      pageSize = parseInt(WorkOrderUtil.getItem('qualityReport.pageSize'));
      if (isNaN(pageSize) || pageSize < 1) {
        pageSize = 10;
      }
    } catch (eps) {
      pageSize = 10;
    }
    this.setState({ 
      fromDate:  fromDate, 
      toDate: toDate,
      pageSize: pageSize,
    }, () => {
      this.filterErrorReportsBy();
    });
  
  }

  toggleRow(id) {
		const newSelected = Object.assign({}, this.state.selected);
		newSelected[id] = !this.state.selected[id];
		this.setState({
			selected: newSelected,
			selectAll: 2
		});
	}

  clearSearchInfo() {
    WorkOrderUtil.removeItem("errorReport.fromDate");
    WorkOrderUtil.removeItem("errorReport.toDate");
    WorkOrderUtil.removeItem("errorReport.pageSize");
    WorkOrderUtil.removeItem("errorReport.page");
    WorkOrderUtil.removeItem("errorReport.errorGroup");
    WorkOrderUtil.removeItem("errorReport.errorDetails");
    WorkOrderUtil.removeItem("errorReport.worker");
    WorkOrderUtil.removeItem("errorReport.reporter");
  }
  saveSearchInfo(fromDate, toDate, pageSize, page, errorGroup, errorDetails, worker, reporter){
    WorkOrderUtil.saveItem("errorReport.fromDate", fromDate);
    WorkOrderUtil.saveItem("errorReport.toDate", toDate);
    WorkOrderUtil.saveItem("errorReport.pageSize", pageSize);
    WorkOrderUtil.saveItem("errorReport.page", page);
    WorkOrderUtil.saveItem("errorReport.page", errorGroup);
    WorkOrderUtil.saveItem("errorReport.page", errorDetails);
    WorkOrderUtil.saveItem("errorReport.page", worker);
    WorkOrderUtil.saveItem("errorReport.page", reporter);
  }

  onFilter() {
    this.clearSearchInfo();
    this.filterErrorReportsBy();
  }

  onExport(){
    let fromDate = this.state.fromDate;
    let toDate = this.state.toDate;
    let worker = this.state.selectedWorker;
    let errorGroup = this.state.selectedErrorGroup;
    let errorDetails = this.state.selectedErrorDetails;
    let reporter = this.state.selectedErrorReporter;
    this.setState({ spinnerVisible: true });
    let page = this.state.selectedPage === undefined? 0: this.state.selectedPage;
    let pageSize = this.state.pageSize === undefined? 10: this.state.pageSize;   


    ErrorReportService.exportToExcel(page, pageSize, fromDate, toDate, worker, errorGroup, errorDetails, reporter).then(data => {
      const downloadUrl = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.setAttribute('download', "ErrorReport_" + fromDate + "_" + toDate + ".xlsx");
      document.body.appendChild(link);
      link.click();
      link.remove();
      this.sleep(1000).then(() => {this.setState({spinnerVisible: false});});
    });
  }

  filterErrorReportsBy(){   
    let fromDate = this.state.fromDate;
    let toDate = this.state.toDate;
    let worker = this.state.selectedWorker;
    let errorGroup = this.state.selectedErrorGroup;
    let errorDetails = this.state.selectedErrorDetails;
    let reporter = this.state.selectedErrorReporter;

    if ((this.state.selectedPage < 0) || (this.state.pageSize < 0)){
      return;
      }

      this.setState({ loading: true });
      let page = this.state.selectedPage === undefined? 0: this.state.selectedPage;
      let pageSize = this.state.pageSize === undefined? 10: this.state.pageSize;   

      
      this.saveSearchInfo(fromDate, toDate, pageSize, page, errorGroup, errorDetails, worker, reporter);
      ErrorReportService.fetchErrorReportBy(page, pageSize, fromDate, toDate, worker, errorGroup, errorDetails, reporter)
      .then(data => { 
        if(data !== undefined && data.message === undefined &&  data.errorReports instanceof Array){
          this.setState({ errorReports: data.errorReports, spinnerVisible: false, loading: false, pages: data.totalPages, page: data.currentPage, pageSize: pageSize}, () =>{
            StatisticService.getErrorReportStatistics(fromDate, toDate, worker, errorGroup, errorDetails, reporter).then(st => {
              if (st !== undefined && st !== null) {
                this.setState({ errorReportStatistics: st })
              }
            });

            StatisticService.getErrorReportStatisticsByDays(fromDate, toDate, worker, errorGroup, errorDetails, reporter).then(st => {
              if (st !== undefined && st !== null) {
                this.setState({ errorReportStatisticsByDays: st })
              }
            });
          });
        }else{
          this.setState({ errorReports: [], loading: false, pages: 0, page: 0, pageSize: pageSize, errorReportStatistics: [], errorReportStatisticsByDays:[]});
        }   
    });
  }

  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  handleFromDateChange(date){
    let sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(date);
    this.setState({                 
      fromDate: sDate                   
    });
  }

  handleToDateChange(date){
    let sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(date);
    this.setState({                 
      toDate: sDate                   
    });
  }

  renderErrorReports () {
    return(<>
      <ReactTable
        manual={true}
        NoDataComponent={() => null}
        previousText={"<"}
        nextText={">"}
        page={this.state.page}
        pages={this.state.pages}
        onPageChange={pageIndex => {
          this.setState({ selectedPage: pageIndex }, () => {
            this.filterErrorReportsBy()
          })
        }}
        onPageSizeChange={(pageSize, pageIndex) => {
          console.log("pageSize: " + pageSize);
          this.setState({ page: pageIndex, pageSize: pageSize }, () => {
            this.filterErrorReportsBy()
          });
        }}
        data={this.state.errorReports}
        columns={this.state.columns}
        defaultPageSize={this.state.pageSize}
        showPageSizeOptions={true}
        pageSizeOptions={[5, 10, 20, 50]}
        getTrProps={(state, rowInfo, column) => {
          if (rowInfo && rowInfo.row) {
            return {
              onClick: (e) => {
                this.setState({
                  selectedRow: rowInfo.index,
                  workOrderId: rowInfo.original.id
                }, () => {
                  WorkOrderUtil.saveItem('errorReport.selectedRow', this.state.selectedRow);
                })
              },
              style: {
                background: rowInfo.index === this.state.selectedRow ? '#DCDCDC' : 'white',
                color: rowInfo.index === this.state.selectedRow ? 'white' : 'black'
              }
            }
          } else {
            return {}
          }
        }
        }
        onSortedChange={(c, s) => {
        }}
      />
    </>);
  }

  null2Unknow(desc){
    return desc === null || desc === undefined? "" : desc;
  }

  renderPieChart(){
    if (this.state.errorReportStatistics === undefined){
      return (<></>);
    }

    let data = [];
    let total = 0;
    data.push(['Error', 'Count']);
    for(let i = 0; i< this.state.errorReportStatistics.length; i++){
      let it = this.state.errorReportStatistics[i];
      let subData = [ it.name + " - " + this.null2Unknow(it.desc),  it.count];
      total += it.count;
      data.push(subData);
    }

    const options = {
      title: "Lỗi từ " + this.state.fromDate + " đến " + this.state.toDate + ": Total: " + total,
      pieSliceText: 'value',
    };

    return (
      <div style={{width:'100%', height: '100%'}}>
      <Chart
      chartType="PieChart"
      data={data}
      options={options}
      width={"100%"}
      height={"100%"}
    />
    </div>
    );
  }

  renderLineChart(){
    if (this.state.errorReportStatisticsByDays === undefined || this.state.errorReportStatisticsByDays.length <= 0){
      return (<></>);
    }

    let data = [];
    data.push(['Error', 'Count']);
    let total = 0;
    for(let i = 0; i< this.state.errorReportStatisticsByDays.length; i++){
      let it = this.state.errorReportStatisticsByDays[i];
      let subData = [ it.name,  it.count];
      total += it.count;
      data.push(subData);
    }

    const options = {
      title: "Lỗi từ " + this.state.fromDate + " đến " + this.state.toDate + ": Total: " + total,
      pieSliceText: 'value',
    };
    return (
      <div style={{width:'100%', height: '500px'}}>
        <div style={{width:'100%'}}>
          Total: { total }
        </div>
        <div style={{width:'100%', height: '95%'}}>
        <Chart
        chartType="ColumnChart"
        data={data}
        options={options}
        width={"100%"}
        height={"100%"}
      />
      </div>
    </div>
    );
  }

  render() {
    if (!AuthenticationService.isQuality()){
      return (<div>Unauthorized access.</div>);
    }

    return (
          <div>
              <MenuComponent2/>
              <ToastsContainer store={ToastsStore} position="bottom_center" />
              <br/>
              <div className="row">
                <div className="col-12 border-top border-left border-bottom border-light-gray" style={{ padding: '0px'}}>
                  <div className="row">
                    <div className="col-2">
                      <label className="fixlen_t"><b>{couterpart.translate('quality_from_report_date')}</b></label>
                    </div>
                    <div className="col-3">
                      <div className="customDatePickerWidth">
                        <DatePicker name="orderDateFrom" className='field_margin_w100' 
                          dateFormat="MM/dd/yyyy hh:mm"              
                          selected={ WorkOrderUtil.convertToDate(this.state.fromDate)}
                          onChange={this.handleFromDateChange.bind(this)}/>
                      </div>
                    </div>
                    <div className="col-2"><label className="fixlen_t"><b>{couterpart.translate('quality_to_report_date')}</b></label></div>
                    <div className="col-3">
                      <div className="customDatePickerWidth">
                        <DatePicker name="orderDateTo" className='field_margin_w100'
                          dateFormat="MM/dd/yyyy hh:mm"
                          selected={ WorkOrderUtil.convertToDate(this.state.toDate)}
                          onChange={this.handleToDateChange.bind(this)}/>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-2 border-top border-right border-bottom border-light-gray" style={{ padding: '5px'}}>
                    { this.renderErrorGroups() }
                </div>
                <div className="col-2 border-top border-right border-bottom border-light-gray" style={{ padding: '5px'}}>
                    { this.renderErrorDetails() }
                </div>
                <div className="col-2 border-top border-right border-bottom border-light-gray" style={{ padding: '5px'}}>
                    { this.renderWorkers() }
                </div>
                <div className="col-2 border-top border-right border-bottom border-light-gray" style={{ padding: '5px'}}>
                    { this.renderErrorReporters() }
                </div> 
                <div className="col-2 border-top border-right border-bottom border-light-gray" style={{ padding: '5px'}}>
                    <button className="myButton0" onClick={this.onFilter.bind(this)}  style={{ width: "50%", marginTop: "1px"}}><FaFilter color={ICON_COLOR}/>&nbsp;{couterpart.translate('button_filter')}</button>
                </div>
                <div className="col-2 border-top border-right border-bottom border-light-gray" style={{ padding: '5px'}}>
                    <button className="myButton0" onClick={this.onExport.bind(this)}  style={{ width: "50%", marginTop: "1px"}}><FaFilter color={ICON_COLOR}/>&nbsp;{couterpart.translate('error_report_export')}</button>
                </div>                
              </div>
              <div className="row">
                <div className="col-6 border-top border-left border-right border-bottom border-light-gray" style={{ padding: '1px'}}>
                  { this.renderErrorReports() }
                </div>
                <div className="col-6 border-top border-left border-right border-bottom border-light-gray" style={{ padding: '1px'}}>
                  {this.renderPieChart() }
                </div>               
              </div>

              <div className="row">
                <div className="col-12 border-top border-left border-right border-bottom border-light-gray" style={{ padding: '1px'}}>
                  {this.renderLineChart() }
                </div>               
              </div>
              <Spinner size={25} spinnerColor={ICON_COLOR} spinnerWidth={2} visible={this.state.spinnerVisible} />
              <Dialog ref={(component) => { this.dialog = component }} />
          </div>      
    )
  }
}
export default withRouter(ErrorReport);